var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 517,
    height: 110,
    viewBox: "0 0 517 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.1864 91.9766C34.2717 91.9766 18.3715 77.791 18.3715 54.9111C18.3715 33.4041 31.9555 17.8456 54.1864 17.8456C64.0662 17.8456 73.1744 21.8123 79.6574 28.2179L92.3161 15.7104C82.5915 5.94854 69.1598 0 54.1864 0C22.5384 0 0 22.7266 0 54.9111C0 88.4686 24.3919 109.822 54.1864 109.822C69.1598 109.822 82.5915 103.874 92.3161 94.2652L79.6574 81.6043C73.1744 88.01 64.0662 91.9766 54.1864 91.9766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M186.33 109.793V1.54541H168.423V78.5554L114.547 1.54541H96.3306V109.793H114.392V32.7826L168.114 109.793H186.33Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.55 18.0917V1.54541H187.256V18.0917H209.949V109.793H227.857V18.0917H250.55Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M341.013 109.793V1.54541H323.106V78.5554L269.23 1.54541H251.013V109.793H269.074V32.7826L322.797 109.793H341.013Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M369.109 1.54541H351.047V109.793H369.109C395.97 109.793 432.248 101.907 432.248 55.669C432.248 7.5761 395.353 1.54541 369.109 1.54541ZM369.109 92.164V19.174C369.109 19.174 414.032 12.3704 414.032 55.669C414.032 98.3487 369.109 92.164 369.109 92.164Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M495.387 109.793H516.538L487.206 62.7821C497.704 59.8444 510.98 52.2665 510.98 33.0921C510.98 1.54541 474.856 1.54541 474.856 1.54541H438.886V19.6375L456.022 46.6993H438.886V109.793H456.949V64.6388H467.291L495.387 109.793ZM477.171 46.5453L460.344 19.6375H474.856C474.856 19.6375 492.917 19.6375 492.917 33.0921C492.917 43.7617 481.957 46.0818 477.171 46.5453Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ded6b03f13d59c21d376226af7fb69fc.svg";
export { ForwardRef as ReactComponent };